// extracted by mini-css-extract-plugin
export default {"customerParam":"L6HSpBzupT_bJV9KFsZo","title":"EOiEvgw8JNkMkkjtTVUz","value":"NSPp8fkgtWMglUD_DIAU"};